var Handlebars = require("/root/project/webapp/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression;

  return "    <span class=\"is-suspended\">\n        <span class=\"suspended-prefix\">\n            ("
    + alias1(__default(require("/root/project/webapp/src/common/ui/template/helper/i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"module/word:suspended",{"name":"i18n","hash":{},"data":data}))
    + ")\n        </span>\n        "
    + alias1(container.lambda((depth0 != null ? depth0.name : depth0), depth0))
    + "\n    </span>\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "    "
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.name : depth0), depth0))
    + "\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.isSuspended : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "");
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./common/ui/template/group/member-name.hbs
// module id = 692
// module chunks = 0